import { render, staticRenderFns } from "./instituciones-autoridades.vue?vue&type=template&id=ffa142a0"
import script from "./instituciones-autoridades.vue?vue&type=script&lang=js"
export * from "./instituciones-autoridades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports